export interface VerifyApplePaymentResponse {
  success: boolean;
  subscriptionStatus?: "ACTIVE" | "EXPIRED" | "CANCELED";
  expirationDate?: string;
  message?: string;
  credits?: number; // Updated credits after payment
  subscription?: string; // Subscription type (standard, premium, booster_5, booster_25)
}

// Calls backend to verify an Apple purchase (JWS or transaction id from native IAP).
export const verifyApplePayment = async (accessAuth0Token: string, receiptData: string, productId?: string): Promise<VerifyApplePaymentResponse> => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/payments/verify-apple`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuth0Token}`,
      },
      body: JSON.stringify({ receiptData, productId }),
      credentials: "include",
    });

    const data = (await response.json()) as VerifyApplePaymentResponse;
    if (!response.ok) {
      return {
        success: false,
        message: data?.message || "Apple payment verification failed",
      };
    }
    return data;
  } catch (error) {
    console.error("verifyApplePayment error:", error);
    return { success: false, message: "Network error" };
  }
};
